import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useQualificationScorecardById = (id) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['qualificationScorecardById', id],
    queryFn: async () => {
      const url = `${prefix}/qualification-scorecards/${id}`;
      const result = await restClient({ url });
      return result;
    },
    enabled: !!id,
    staleTime: 0,
    cacheTime: 0,
  });
};
